export const MENU_ITEMS = [
  {
    name: "About",
    description: [
      "Loves :",
      "- Reading",
      "- Video Games",
      "- Sports",
      "- Coding beautiful features",
    ],
  },
  {
    name: "Skills",
    description: ["Front-End Development", "Desktop & Mobile", "UI/UX Design"],
  },
  {
    name: "Contact",
    description: ["You can find me on ", "LinkedIn", "GitHub"],
  },
]
